import React from "react";
import { Typography, Box, InputLabel, Select, MenuItem } from "@mui/material";
import {
  Refresh as RefreshIcon,
  FilterList as FilterIcon,
} from "@mui/icons-material";
import { GlassHeader, GlassButton, GlassSelect } from "../layouts/GlassTileLayout";

const ActivityFeedHeader = ({
  title,
  onRefresh,
  loading,
  filter,
  onFilterChange,
  activityTypes = [],
}) => {
  return (
    <GlassHeader>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 700,
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {title}
        </Typography>
        <GlassButton
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
          disabled={loading}
          size="small"
        >
          Refresh
        </GlassButton>
      </Box>

      {/* Activity Type Filter */}
      <GlassSelect size="small" sx={{ minWidth: 200 }}>
        <InputLabel>Filter Activities</InputLabel>
        <Select
          value={filter}
          label="Filter Activities"
          onChange={(e) => onFilterChange(e.target.value)}
          startAdornment={<FilterIcon sx={{ mr: 1, opacity: 0.6 }} />}
        >
          <MenuItem value="">All Activities</MenuItem>
          {activityTypes.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </Select>
      </GlassSelect>
    </GlassHeader>
  );
};

export default ActivityFeedHeader;
